import React, { useContext } from "react";
import { TrendingUp } from "lucide-react";
import { ThemeContext } from "../../../../constant/theme";
import { getStatIconBackground } from "../../../../utils/styleUtils";

const StatsGrid = ({ styles, stats, screenSize, gridStyle = {} }) => {
  const { theme } = useContext(ThemeContext);
  const isMobile = screenSize?.isMobile || screenSize === "xs" || screenSize === "sm";
  const isTablet = screenSize === "md";

  // Use parent's gridTemplateColumns if provided, otherwise use responsive defaults
  const gridTemplateColumns = gridStyle?.gridTemplateColumns || (
    isMobile
      ? "1fr"
      : isTablet
        ? "repeat(2, 1fr)"
        : "repeat(4, 1fr)"
  );

  return (
    <div style={{
      ...styles.statsGrid,
      ...gridStyle,
      display: "grid",
      gridTemplateColumns,
      gap: isMobile ? "12px" : isTablet ? "16px" : "20px",
      transition: "all 0.30s ease",
    }}>
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            style={{
              ...styles.statCard,
              background: theme === "dark"
                ? "rgba(255,255,255,0.01)"
                : "rgba(255,255,255,1)",
              padding: isMobile ? "16px" : isTablet ? "18px" : "20px",
              borderRadius: isMobile ? "12px" : "16px",
              transition: "all 0.3s ease",
              boxShadow: theme === "dark"
                ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 8px 32px rgba(0,0,0,0.1)",
              backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
              WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
              border: theme === "dark"
                ? "1px solid rgba(255,255,255,0.15)"
                : "1px solid rgba(0,0,0,0.05)",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = theme === "dark"
                ? "0 12px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 12px 40px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = theme === "dark"
                ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 8px 32px rgba(0,0,0,0.1)";
            }}
          >
            <div style={styles.statHeader}>
              <div
                style={{
                  ...styles.statIconWrapper,
                  background: stat.iconBackground || getStatIconBackground(stat.color),
                  width: isMobile ? "36px" : "40px",
                  height: isMobile ? "36px" : "40px",
                  borderRadius: isMobile ? "6px" : "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#fff",
                  flexShrink: 0,
                }}
              >
                {Icon ? <Icon size={isMobile ? 18 : 24} /> : null}
              </div>
              <p style={{
                ...styles.statTitle,
                fontSize: isMobile ? "12px" : "14px",
                color: theme === "dark"
                  ? "rgba(255,255,255,0.9)"
                  : "rgba(26,26,26,0.7)",
                fontWeight: "500",
                lineHeight: 1.3,
                margin: 0,
              }}>{stat.title}</p>
            </div>
            <h2 style={{
              ...styles.statValue,
              fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
              fontWeight: "700",
              color: theme === "dark" ? "#fff" : "#000",
              textAlign: isMobile ? "center" : "left",
              margin: 0,
              marginBottom: isMobile ? "4px" : "0",
            }}>{stat.value}</h2>
            {stat.description && (
              <p style={{
                fontSize: isMobile ? "12px" : "14px",
                color: theme === "dark"
                  ? "rgba(255,255,255,0.6)"
                  : "rgba(26,26,26,0.6)",
                margin: "8px 0 0 0",
                textAlign: isMobile ? "center" : "left",
              }}>
                {stat.description}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StatsGrid;